import { useState } from 'react';

import { OfferCard } from '@/components/Shared/ui';
import { type TAutoCredLeasingResponse } from '@/types/newOrder';

import { LeasingDetails } from '../../ui';

type TLeasingWaitingItemProps = {
  leasingOffer: TAutoCredLeasingResponse;
};

const LeasingWaitingItem = ({ leasingOffer }: TLeasingWaitingItemProps) => {
  const [isLeasingDetailsModalOpen, setIsLeasingDetailsModalOpen] =
    useState(false);

  return (
    <>
      <OfferCard
        className="bank-item"
        status="warning"
        statusText={leasingOffer.status.name}
        isLeasing
      >
        <OfferCard.Header
          title={leasingOffer.leasingCompany.name}
          icon={leasingOffer.leasingCompany.icon}
          isWaitingOffer
          descriptionAction={
            leasingOffer.comment
              ? {
                  onClick: () => setIsLeasingDetailsModalOpen(true),
                  text: <span className="offer-body__hidden">Описание</span>
                }
              : undefined
          }
        />
      </OfferCard>

      <LeasingDetails
        isModalOpen={isLeasingDetailsModalOpen}
        onClose={() => setIsLeasingDetailsModalOpen(false)}
        leasingOffer={leasingOffer}
      />
    </>
  );
};

export default LeasingWaitingItem;
